import { render } from "./routes.vue?vue&type=template&id=7d620ba2&scoped=true"
import script from "./routes.vue?vue&type=script&lang=js"
export * from "./routes.vue?vue&type=script&lang=js"

import "./routes.vue?vue&type=style&index=0&id=7d620ba2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d620ba2"]])

export default __exports__